export default __webpack_public_path__ + "static/how-to-use-nomba-qr-beed3808c6c8cf020860ae237d4e9aa5.mp4";